import { render, staticRenderFns } from "./RecruitmentListPage.vue?vue&type=template&id=6260bb1e&scoped=true"
import script from "./RecruitmentListPage.vue?vue&type=script&lang=js"
export * from "./RecruitmentListPage.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentListPage.vue?vue&type=style&index=0&id=6260bb1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6260bb1e",
  null
  
)

export default component.exports